// assets/js/components/revenue-calculator/steps/step-5.js
var ui = require("../ui");

function render() {
    var html = ui.stepLabel(_t("Step 5 of 6")) + ui.h2(_t("Get your revenue estimate")) +
        ui.sub(_t("See a quick estimate now, or continue for a deeper and more accurate analysis.")) +
        '<div class="rc-calc__fork">' +
        '<button type="button" class="rc-calc__fork-option" id="rc-quick-btn">' +
        '<div class="rc-calc__fork-title">' + _t("See quick estimate") + "</div>" +
        '<div class="rc-calc__fork-desc">' + _t("Based on what you've told us so far.") + "</div>" +
        "</button>" +
        '<button type="button" class="rc-calc__fork-option" id="rc-advanced-btn">' +
        '<div class="rc-calc__fork-title">' + _t("Continue for deeper analysis") + "</div>" +
        '<div class="rc-calc__fork-desc">' + _t("3 more quick questions for a more detailed and accurate result.") + "</div>" +
        "</button>" +
        "</div>";
    return ui.card(html);
}

function bind(container, state, actions) {
    container.querySelector("#rc-quick-btn").addEventListener("click", function () {
        state.path = "quick";
        state.step = 7;
        actions.rerender();
    });
    container.querySelector("#rc-advanced-btn").addEventListener("click", function () {
        state.path = "advanced";
        state.step = 6;
        state.adv = 0;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
